export default {
    SET_BOOKINGS: 'SET_BOOKINGS',
};



// WEBPACK FOOTER //
// ./src/containers/BookingHistory/BookingHistoryConstants.js